import { useEffect, useState } from 'react'
import { postData } from '../../utils/apiCalls'
import { useGlobalState } from '../../hooks/useGlobalState'
import { ACTIONS } from '../../state'

export const Assign = () => {
   const [currTicketIdx, setCurrTicketIdx] = useState(0)
   const { ticketFields, cart, invalidInputMsg, dispatch } = useGlobalState()

   useEffect(() => {
      dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
      postData('https://youngstartup.io/api/cwebsite-reg/get_ticket_fields', {
         body: {
            tickets: cart
         }
      })
         .then(res => { dispatch({ type: ACTIONS.SET, entity: 'ticketFields', payload: res }) })
         .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
   }, []);

   const handelSubmit = (e) => {
      e.preventDefault()
      setCurrTicketIdx(prev => prev + 1)
   }

   const handelChange = (e) => {
      dispatch({ type: ACTIONS.SET, entity: 'invalidInputMsg', payload: [] })
      dispatch({ type: ACTIONS.UPDATE_TICKET, payload: { id: e.target?.dataset?.id, [e.target.name]: e.target.value } })
   }

   const calcHeight = (size) => {
      if (!size) return '58px'
      if (window.innerWidth > 700) {
         return Math.ceil((size + 1) / 2) * 72 + 58 + 'px'
      }
      return (size + 1) * 72 + 58 + 'px'
   }

   return (
      <div className='assign'>
         <header>
            <h1>Assign Your Tickets</h1>
         </header>
         <main>
            {
               ticketFields && cart.map((t, formIdx) =>
                  <div key={formIdx}>
                     <form style={currTicketIdx === formIdx ? { maxHeight: calcHeight(ticketFields[t.type_id]?.length) } : { maxHeight: '58px' }} onClick={() => { setCurrTicketIdx(formIdx) }} onSubmit={handelSubmit}>
                        <div>
                           <h6>Ticket {formIdx + 1} of {cart.length}</h6>
                           {invalidInputMsg?.find(i => i.ticket === formIdx + 1) && <h5>* Invalid</h5>}
                        </div>
                        <section className='inputs-container'>
                           {ticketFields[t.type_id]?.map((input, inputIdx) =>
                              <div key={inputIdx} className='input'>
                                 {
                                    input.element_type === 'input' &&
                                    <input
                                       placeholder={`enter your ${input.label}`}
                                       id={input.label}
                                       type={input.type}
                                       required={input?.validations?.required}
                                       name={input.internal_name}
                                       value={t[input.internal_name]}
                                       onChange={handelChange}
                                       data-id={t.id}
                                    />
                                 }
                                 {
                                    input.element_type === 'select' &&
                                    <select
                                       name={input.internal_name}
                                       id={input.label}
                                       onChange={handelChange}
                                       value={t[input.internal_name]}
                                       required={input?.validations?.required}
                                    >
                                       <option value="" disabled>Select an option</option>
                                       {
                                          input.options.map((option, optionIdx) =>
                                             <option
                                                key={option.id}
                                                value={option.option_value}
                                             >{option.option_display}</option>
                                          )
                                       }
                                    </select>
                                 }
                                 <label htmlFor={input.id}>{input.label}</label>
                                 <div className='error'>
                                    {invalidInputMsg?.find(i => i.ticket === formIdx + 1 && i.field === input.internal_name)?.msg}
                                 </div>
                              </div>
                           )}
                           <button className='btn'>
                              {formIdx === cart.length - 1 ? 'Next' : 'Next Ticket'}
                           </button>
                        </section>
                     </form>
                  </div>
               )}
         </main>
      </div>
   )
}
